import { useEffect, useState } from "react";
import { isStringArray } from "utils";

export interface SelectOptions {
    name: string;
    // eslint-disable-next-line
    value: any;
}

interface SelectModel {
    translation: string;
    field?: string;
    name?: string;
    code?: number;
}

export const useSelectOptions = (fields: Readonly<SelectModel[]> | string[]) => {
    const [fieldOptions, setFieldOptions] = useState<SelectOptions[]>([{ name: "", value: "" }]);

    useEffect(() => {
        if (isStringArray(fields)) {
            const options = fields.map((value) => {
                return {
                    name: value,
                    value,
                };
            });

            return setFieldOptions(options);
        }

        const fieldOptions = fields.map(({ name, field, translation, code }) => {
            return {
                name: translation || name || "",
                value: code || field || name || "",
            };
        });

        setFieldOptions(fieldOptions);
        // eslint-disable-next-line
    }, [fields.length]);

    return fieldOptions;
};
